import { CommonModule, isPlatformBrowser } from '@angular/common'
import { Component, HostListener, Inject, inject, PLATFORM_ID, signal } from '@angular/core'
import { RouterModule } from '@angular/router'
import { TranslocoDirective } from '@jsverse/transloco'
import { AnalyticsService } from '../../services/analytics.service'
import { scrollToAnchor } from '../../utils/scroll-utils'
import { LanguagePickerComponent } from '../language-picker/language-picker.component'

@Component({
    selector: 'endevelo-top-nav',
    imports: [CommonModule, RouterModule, TranslocoDirective, LanguagePickerComponent],
    templateUrl: './top-nav.component.html',
    styleUrl: './top-nav.component.scss'
})
export class TopNavComponent {
    private analytics = inject(AnalyticsService)
    public window = {} as Window
    mobileMenuOpen = signal(false)
    isMobile = false

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

    toggleMobileMenu() {
        this.mobileMenuOpen.set(!this.mobileMenuOpen())
    }

    closeMobileMenu() {
        this.mobileMenuOpen.set(false)
    }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.window = window
            this.checkIfMobile()
        }
    }
    // Close menu when screen size changes to desktop view
    @HostListener('window:resize')
    onResize() {
        if (isPlatformBrowser(this.platformId)) {
            this.checkIfMobile()
            if (window.innerWidth >= 1024) {
                this.mobileMenuOpen.set(false)
            }
        }
    }

    private checkIfMobile(): void {
        this.isMobile = window.innerWidth < 1024
    }

    handleScrollToAnchor(anchorId: string) {
        const scrollPerformed = scrollToAnchor(anchorId)
        if (scrollPerformed) {
            this.mobileMenuOpen.set(false) // Close menu after navigation
        }
    }

    trackNavClick(destination: string) {
        this.analytics.trackNavigation(destination, 'top_nav')
    }

    trackCTAClick(ctaName: string) {
        this.analytics.trackCTAClick(ctaName, 'top_nav')
    }
}
